var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChartStackedBarsNormalized } from '../svg-elements/module';
import * as d3 from 'd3';
import { HtmlLegendDots } from "../html-elements/module";
import { parseGroups } from '../d3-services/data.functions';
import { GraphControllerV2 } from './graph-v2';
var NormalisedBars = /** @class */ (function (_super) {
    __extends(NormalisedBars, _super);
    function NormalisedBars(main, data, element, mapping, segment) {
        var _this = _super.call(this, main, data, element, mapping, segment) || this;
        _this.main = main;
        _this.data = data;
        _this.element = element;
        _this.mapping = mapping;
        _this.segment = segment;
        _this.pre();
        return _this;
    }
    NormalisedBars.prototype.pre = function () {
        this._addScale('x', 'linear', 'horizontal', 'group');
        this._addScale('y', 'band', 'vertical-reverse', 'group');
        this._addMargin(0, 30, 0, 0);
        this._addPadding(0, 0, 0, 0);
    };
    NormalisedBars.prototype.init = function () {
        var self = this;
        this.config.paddingInner = .5;
        this.config.paddingOuter = .5;
        _super.prototype._init.call(this);
        var svgId = "svg-wrapper-" + this.mapping.slug;
        var container = document.createElement('section');
        container.style.height = "280px";
        container.style.width = "100%";
        container.id = svgId;
        this.element.appendChild(container);
        _super.prototype._svg.call(this, container);
        this.chartStackedBarsNormalized = new ChartStackedBarsNormalized(this);
        this.legend = new HtmlLegendDots(this);
        this.update(this.data, this.segment, false);
    };
    NormalisedBars.prototype.prepareData = function (data) {
        var grouped = parseGroups(this.mapping, data);
        // voor y-axis ... we groeperen op tijdsduur (=group .. duh) 
        this.labels = grouped.map(function (g) { return g.label; });
        //  keys for stacking dit zijn de procedurestappen 
        this.keys = Object.keys(grouped[0]).filter(function (k) { return k != 'label'; });
        this.normalizedStack = d3.stack()
            .offset(d3.stackOffsetExpand)
            .keys(this.keys);
        // console.log(this.keys);
        // console.log(grouped);
        return {
            "history": null,
            "latest": null,
            "slice": null,
            "grouped": grouped,
            "stacked": this.normalizedStack(grouped)
        };
        // serie is grouping for stacked --> ontvangst, opname, etc -- niet de data groepering
        // rijen corresponderen met data groupings 
    };
    NormalisedBars.prototype.draw = function (data) {
        // with data we can init scales
        this.scales.x.set([0, 1]);
        // we need one system for yscale ..
        this.scales.y.set(this.labels);
        // width data we can draw items
        this.chartStackedBarsNormalized.draw(data);
    };
    NormalisedBars.prototype.redraw = function (data) {
        _super.prototype.redraw.call(this, data);
        this.chartStackedBarsNormalized.redraw();
    };
    NormalisedBars.prototype.update = function (data, segment, update) {
        _super.prototype._update.call(this, data, segment, update);
    };
    return NormalisedBars;
}(GraphControllerV2));
export default NormalisedBars;
